import { createGlobalStyle } from 'styled-components';

// Compact the live workspace controls; dialogs retain the shared modal sizing.
// Media overlays, product thumbnails and inline chat names keep their content sizing.
const LiveCompactControls = createGlobalStyle`
  html[data-admin-design] body :is(p, h1, h2, h3, td, th, label, span, strong, small, [data-chat-name], [data-chat-content]) {
    user-select: text; -webkit-user-select: text;
  }

  html[data-admin-design] body
  :is(button, .admin-header-action):not(:where(#live-detail-sidebar *)):not(:where([data-admin-tabs] *)):not([data-chat-name]):not([data-live-image-control]):not([data-live-media-display] *):not(:where([data-admin-modal] *)) {
    box-sizing: border-box;
    height: var(--control-sm); min-height: var(--control-sm); min-width: var(--control-sm);
    padding-block: 0; padding-inline: var(--space-2);
    gap: var(--gap-icon); border-radius: var(--radius-md);
    font-family: var(--font-family-base); font-size: var(--admin-search-button-font, var(--text-caption)); line-height: var(--leading-caption);
  }

  html[data-admin-design] body
  :is(input:not([type="checkbox"]):not([type="radio"]):not([type="file"]):not([type="hidden"]):not([type="range"]), select):not(:where(#live-detail-sidebar *)):not([data-live-media-display] *):not(:where([data-admin-modal] *)) {
    box-sizing: border-box; height: var(--control-sm); min-height: var(--control-sm);
    padding-block: 0; padding-inline: var(--space-2); border-radius: var(--radius-md);
    font-family: var(--font-family-base); font-size: var(--text-body);
  }

  html[data-admin-design] body button[data-live-icon-control]:not(:where([data-admin-modal] *)) {
    flex-basis: var(--control-sm); width: var(--control-sm); min-width: var(--control-sm); padding: 0;
  }
  html[data-admin-design] body button[data-live-icon-control]:not(:where([data-admin-modal] *)) > :is(svg, img) {
    width: var(--space-4); height: var(--space-4);
  }
  html[data-admin-design] body button[data-chat-menu-trigger]:not([data-chat-name]):not(:where([data-admin-modal] *)) {
    width: var(--control-sm); min-width: var(--control-sm); padding: 0;
  }

  html[data-admin-design] body [data-live-control-label]:not(:where([data-admin-modal] *)) {
    box-sizing: border-box; min-height: var(--control-sm); padding-inline: var(--space-2);
    gap: var(--space-2); border-radius: var(--radius-md); font-size: var(--text-caption);
  }
  html[data-admin-design] body [data-live-control-label] input[type="checkbox"] {
    width: var(--space-5); height: var(--space-5);
  }
  html[data-admin-design] body [aria-label="라이브 상품 바로 등록"] label {
    min-height: var(--control-sm);
  }
  html[data-admin-design] body [aria-label="라이브 상품 바로 등록"] input:not([type="checkbox"]) {
    margin-top: 0;
  }

  @media (pointer: coarse) {
    html[data-admin-design] body
    :is(button, .admin-header-action):not(:where(#live-detail-sidebar *)):not(:where([data-admin-tabs] *)):not([data-chat-name]):not([data-live-image-control]):not([data-live-media-display] *):not(:where([data-admin-modal] *)),
    html[data-admin-design] body
    :is(input:not([type="checkbox"]):not([type="radio"]):not([type="file"]):not([type="hidden"]):not([type="range"]), select):not(:where(#live-detail-sidebar *)):not([data-live-media-display] *):not(:where([data-admin-modal] *)) {
      height: var(--touch-target); min-height: var(--touch-target); min-width: var(--touch-target);
    }
    html[data-admin-design] body button[data-live-icon-control]:not(:where([data-admin-modal] *)) {
      flex-basis: var(--touch-target); width: var(--touch-target); min-width: var(--touch-target);
    }
    html[data-admin-design] body button[data-chat-menu-trigger]:not([data-chat-name]):not(:where([data-admin-modal] *)) {
      width: var(--touch-target); min-width: var(--touch-target);
    }
    html[data-admin-design] body [data-live-control-label]:not(:where([data-admin-modal] *)),
    html[data-admin-design] body [aria-label="라이브 상품 바로 등록"] label {
      min-height: var(--touch-target);
    }
  }
`;

export default LiveCompactControls;
